// Instrument-workshop visuals (machined metal, brass graduations, sapphire glass). No people.
export const IMG = {
  heroBg: "/img/bg.jpg",
  studio: "/img/studio.jpg",
  webinar: "/img/webinar.jpg",
  vslCover: "/img/vsl.jpg",
  avatarFemale: "/img/studio.jpg",
  avatarMale: "/img/webinar.jpg",
  avatarThird: "/img/vsl.jpg",
};
